import { useId, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../lib/apiClient";
import { setToken } from "../lib/auth";
import "./adminLogin.css";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const usernameId = useId();
  const passwordId = useId();

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      // apiRequest reads `error`, `message` and `errors[].msg`. That matters
      // here: rate limiting replies { error: "Too many login attempts…" }, so
      // reading only `message` showed a locked-out admin "Invalid credentials"
      // and invited them to keep hammering the form.
      const data = await apiRequest("/api/auth/login", {
        method: "POST",
        body: { username, password },
      });

      setToken(data.token);
      navigate("/admin-dashboard", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Admin <span className="gold">Portal</span></h1>

        {error && (
          <div className="error-message" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor={usernameId}>Username</label>
            <input
              id={usernameId}
              type="text"
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor={passwordId}>Password</label>
            <input
              id={passwordId}
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Authenticating…" : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
